import { BaseError } from 'make-error';

export class MessagingClientError extends BaseError {
    constructor(message = 'An unknown error occurred.') {
        super(message);
    }
}

export class MessagingClientConnectionError extends MessagingClientError {
    constructor(message = 'Connection failure.') {
        super(message);
    }
}

export class MessagingClientSubscriptionError extends MessagingClientError {
    constructor(message = 'Failed to subscribe to channel.') {
        super(message);
    }
}

export class DuplicateRpcDeclarationError extends MessagingClientError {
    constructor(message = 'An RPC with the same name was declared more than once.') {
        super(message);
    }
}

export class UndefinedRpcError extends MessagingClientError {
    constructor(message = 'An RPC with that name has not been declared.') {
        super(message);
    }
}
